export default __webpack_public_path__ + "static/media/logo.2020da73.svg";